import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';

import SubmitRow from 'js/components/core/Modal/SubmitRow';
import ClockIcon from 'js/components/core/Icons/ClockIcon';
import ContinueButton from 'js/components/core/SteppedPage/ContinueButton';

import Container from './Container';
import Title from './Title';
import IconRow from './IconRow';
import TimeRow from './TimeRow';
import TimeInput from './TimeInput';
import SkipButton from './SkipButton';

@inject('page')
@observer
export default class PickupTime extends Component {
  nextStepWithPickupTime = () => this.props.page.setDelivery('scheduled-shipment').nextStep();
  nextStep = () => this.props.page.setDelivery('shipment').nextStep();

  render() {
    const pickup_time = this.props.page.pickup_time;
    return (
      <Container>
        <IconRow>
          <ClockIcon />
        </IconRow>

        <Title>When will you have your item ready for pickup?</Title>

        <TimeRow>
          <TimeInput
            time={pickup_time}
            minuteStep={15}
            limit={{ start: { hour: 6, minute: 0 }, end: { hour: 18, minute: 30 } }}
          />
        </TimeRow>

        <SubmitRow>
          <ContinueButton onClick={this.nextStepWithPickupTime}>Continue</ContinueButton>
          <SkipButton onClick={this.nextStep}>Skip, it's ready for pickup anytime</SkipButton>
        </SubmitRow>
      </Container>
    );
  }
}
